module.exports = __webpack_public_path__ + "static/img/patho-pierced-eardrum-DrOt73Ot.690f474f.png";